
import { useEffect, useState } from "react";
import { Alert, Box, Grid, Tab, Tabs, Typography, } from "@mui/material";
import { a11yProps, sizeTab, useCheckPermissions } from "@/shared";

import { SampleTable, SingleTableBoxScene } from "@/shared/components/ui";
import { CustomTabPanel } from "@/erp/sale/component";
import { PermissionsEnum } from "@/auth/interfaces";
import ModalAgregarConfiguracion from "../components/ModalAgregarConfiguracion";
import { Add } from "@mui/icons-material";
import { useGetConfiguracionTransito, useDeleteConfiguracionTransito } from "../actions/configuracion-inventario.actions";
import { useTablaColumnsConfiguracionTransito } from "../hooks/useTablaConfiguracionTransito";
import { toast } from "react-toastify";

export default function ConfiguracionTransitoPage() {

    useCheckPermissions(PermissionsEnum.api_view_configuraciontransito);

    const [open, setOpen] = useState(false);
    const [valueTab, setValueTab] = useState(0);

    const [listaConfiguracionTransito, setListaConfiguracionTransito] = useState<any[]>([]);
    const useGetConfiguracionTransitoMutation = useGetConfiguracionTransito();
    const useDeleteConfiguracionTransitoMutation = useDeleteConfiguracionTransito();

    const fetchData = async () => {
        const response = await useGetConfiguracionTransitoMutation.mutateAsync([]) as any;
        setListaConfiguracionTransito(response.data?.data ?? []);
    };

    const handleDelete = async (row: any) => {
        try {
            const data = await useDeleteConfiguracionTransitoMutation.mutateAsync(row.id_configuracion_transito);
            fetchData();
            toast.success(data.message || 'Elemento eliminado');
        } catch (err: any) {
            console.log(err.message)
            toast.error(err.message || 'Ocurrio un error');
        }
    }

    const { columnsConfiguracionTransito } = useTablaColumnsConfiguracionTransito(handleDelete);

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <SingleTableBoxScene
                title={"Configuración de Tránsitos"}
                enableAccionBtn={listaConfiguracionTransito.length > 0 ? false : true}
                fnAccionBtn={() => setOpen(true)}
                iconActionBtn={<Add />}
                labelTextActionBtn={"Agregar"}
            >

                <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
                    <Tabs
                        value={valueTab}
                        onChange={(_event: React.SyntheticEvent, newValue: number) => {
                            setValueTab(newValue);
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs preventa"
                    >
                        <Tab label={"Parametros de Crontab"} {...a11yProps(0)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={valueTab} index={0}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Alert severity="info" sx={{ bgcolor: "info.light" }}>
                                <Typography variant="body2">
                                    <strong>Información:</strong> La configuración registrada, permite ejecutar una tarea programada para actualizar los transitos vencidos.
                                </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12}>
                            <SampleTable
                                columns={columnsConfiguracionTransito}
                                data={listaConfiguracionTransito}
                            />
                        </Grid>
                    </Grid>
                </CustomTabPanel>

            </SingleTableBoxScene >

            {open && (
                <ModalAgregarConfiguracion
                    open
                    onClose={() => setOpen(false)}
                    fetchData={fetchData}
                />
            )}
        </>
    );

}